import React from "react";
import "./fundos.css";

import EditalConvocacaoFicFim from "../assets/docs/Edital-de-Convocacao-de-Assembleia-Geral-de-Cotistas-do-Fundo-ORION-FIC-FIM-de-25-de-maio-de-2023.pdf";
import EditalConvocacao from "../assets/docs/Edital_Reconvocacao_AGC-230306_Captalys_Orion_Poligono_nova_gestora-.pdf";
import EditalConvocacaoAnexoI from "../assets/docs/Captalys-Orion-AGC-Edital-de-Convocacao-Anexo-I-Versao-Marcada-do-Regulamento.pdf";
import EditalConvocacaoAnexoII from "../assets/docs/Captalys-Orion-AGC-Edital-de-Convocacao-Anexo-II-Versao-Limpa-do-Regulamento.pdf";
import EditalConvocacaoAnexoIII from "../assets/docs/Captalys-Orion-AGC-Edital-de-Convocacao-Anexo-III-Fundos-Alvo.pdf";
import UltimoRelatorioMensal from "../assets/docs/Orion-FIC-FIM-CP-Material-de-Divulgacao-Marco-2024.pdf";


const Orion = () => {
    return (
        <main id="main-container">
            <div id="secao-comunicados">
                <div id="container">
                    <h2 className="text-3xl font-bold text-center">Comunicados</h2>
                    <div className="flex flex-col">
                        <div id="container-comunicados">
                            <div>
                                <p><strong className="text-2xl">25 de maio de 2023</strong></p>
                                <br />
                                <a
                                    href={EditalConvocacaoFicFim}
                                    rel="noreferrer"
                                    target="_blank"
                                    className="button"
                                >
                                    Edital de Convocação – Orion FIC FIM
                                </a>
                            </div>
                            <div>
                                <p><strong className="text-2xl">17 de fevereiro de 2023</strong></p>
                                <br />
                                <a
                                    href={EditalConvocacao}
                                    rel="noreferrer"
                                    target="_blank"
                                    className="button"
                                >
                                    Edital de Convocação
                                </a>
                            </div>
                            <div>
                                <p><strong className="text-2xl">17 de fevereiro de 2023</strong></p>
                                <br />
                                <a
                                    href={EditalConvocacaoAnexoI}
                                    rel="noreferrer"
                                    target="_blank"
                                    className="button"
                                >
                                    Edital de Convocação - Anexo 1
                                </a>
                            </div>
                            <div>
                                <p><strong className="text-2xl">17 de fevereiro de 2023</strong></p>
                                <br />
                                <a
                                    href={EditalConvocacaoAnexoII}
                                    rel="noreferrer"
                                    target="_blank"
                                    className="button"
                                >
                                    Edital de Convocação - Anexo 2
                                </a>
                            </div>
                        </div>
                        <div id="container-comunicados">
                            <div>
                                <p><strong className="text-2xl">17 de fevereiro de 2023</strong></p>
                                <br />
                                <a
                                    href={EditalConvocacaoAnexoIII}
                                    rel="noreferrer"
                                    target="_blank"
                                    className="button"
                                >
                                    Edital de Convocação - Anexo 3
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <section id="secao-rentabilidade">
                <h2 className="text-3xl font-bold text-center">Rentabilidade</h2>
                <p className="text-center">Acesse aqui o último Relatório Mensal do Fundo Orion:</p>
                <div id="container-rentabilidade">
                    <div id="ultimo-relatorio">
                        <strong className="text-lg">Março</strong>
                        <br />
                        <br />
                        <a
                            href={UltimoRelatorioMensal}
                            rel="noreferrer"
                            target="_blank"
                            className="button"
                            alt="Orion - Último relatório de rentabilidade"
                        >
                            Clique aqui para baixar
                        </a>
                    </div>
                </div>
            </section>
            <section id="historico" className="mb-8">
                <h2 className="text-3xl font-bold mb-4">Histórico</h2>
                <div id="detalhes-historico">
                    <details>
                        <summary className="sumario">
                            Histórico da gestão anterior | Período de 21 de setembro de 2011 até 16 de abril de 2023
                        </summary>
                        <div className="mt-4">
                            <table className="w-full table">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th>JAN</th>
                                        <th>FEV</th>
                                        <th>MAR</th>
                                        <th>ABR</th>
                                        <th>MAI</th>
                                        <th>JUN</th>
                                        <th>JUL</th>
                                        <th>AGO</th>
                                        <th>SET</th>
                                        <th>OUT</th>
                                        <th>NOV</th>
                                        <th>DEZ</th>
                                        <th>ANO</th>
                                        <th>INÍCIO DO FUNDO</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td rowspan="2">2011</td>
                                        <td>Fundo</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>0.40%*</td>
                                        <td>1.04%</td>
                                        <td>1.02%</td>
                                        <td>1.03%</td>
                                        <td>3.52%</td>
                                        <td>3.52%</td>
                                    </tr>
                                    <tr>
                                        <td>% CDI</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>127%</td>
                                        <td>118%</td>
                                        <td>118%</td>
                                        <td>113%</td>
                                        <td>118%</td>
                                        <td>118%</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2">2012</td>
                                        <td>Fundo</td>
                                        <td>1.26%</td>
                                        <td>1.50%</td>
                                        <td>1.15%</td>
                                        <td>0.94%</td>
                                        <td>1.16%</td>
                                        <td>0.92%</td>
                                        <td>0.91%</td>
                                        <td>1.01%</td>
                                        <td>1.05%</td>
                                        <td>1.21%</td>
                                        <td>1.12%</td>
                                        <td>1.20%</td>
                                        <td>14.28%</td>
                                        <td>18.31%</td>
                                    </tr>
                                    <tr>
                                        <td>% CDI</td>
                                        <td>142%</td>
                                        <td>202%</td>
                                        <td>142%</td>
                                        <td>134%</td>
                                        <td>158%</td>
                                        <td>144%</td>
                                        <td>135%</td>
                                        <td>147%</td>
                                        <td>196%</td>
                                        <td>199%</td>
                                        <td>206%</td>
                                        <td>224%</td>
                                        <td>170%</td>
                                        <td>157%</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2">2013</td>
                                        <td>Fundo</td>
                                        <td>1.11%</td>
                                        <td>0.91%</td>
                                        <td>1.16%</td>
                                        <td>1.04%</td>
                                        <td>0.95%</td>
                                        <td>0.97%</td>
                                        <td>1.11%</td>
                                        <td>0.83%</td>
                                        <td>0.91%</td>
                                        <td>1.18%</td>
                                        <td>1.03%</td>
                                        <td>1.19%</td>
                                        <td>13.10%</td>
                                        <td>33.81%</td>
                                    </tr>
                                    <tr>
                                        <td>% CDI</td>
                                        <td>189%</td>
                                        <td>188%</td>
                                        <td>215%</td>
                                        <td>173%</td>
                                        <td>164%</td>
                                        <td>163%</td>
                                        <td>157%</td>
                                        <td>120%</td>
                                        <td>130%</td>
                                        <td>147%</td>
                                        <td>145%</td>
                                        <td>153%</td>
                                        <td>163%</td>
                                        <td>164%</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2">2014</td>
                                        <td>Fundo</td>
                                        <td>1.30%</td>
                                        <td>1.11%</td>
                                        <td>0.94%</td>
                                        <td>1.24%</td>
                                        <td>1.04%</td>
                                        <td>0.95%</td>
                                        <td>1.11%</td>
                                        <td>1.06%</td>
                                        <td>1.06%</td>
                                        <td>1.27%</td>
                                        <td>1.15%</td>
                                        <td>1.40%</td>
                                        <td>14.52%</td>
                                        <td>53.24%</td>
                                    </tr>
                                    <tr>
                                        <td>% CDI</td>
                                        <td>155%</td>
                                        <td>142%</td>
                                        <td>123%</td>
                                        <td>153%</td>
                                        <td>121%</td>
                                        <td>116%</td>
                                        <td>118%</td>
                                        <td>123%</td>
                                        <td>118%</td>
                                        <td>135%</td>
                                        <td>137%</td>
                                        <td>147%</td>
                                        <td>134%</td>
                                        <td>158%</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2">2015</td>
                                        <td>Fundo</td>
                                        <td>1.41%</td>
                                        <td>1.22%</td>
                                        <td>1.56%</td>
                                        <td>1.45%</td>
                                        <td>1.45%</td>
                                        <td>1.53%</td>
                                        <td>1.72%</td>
                                        <td>1.52%</td>
                                        <td>1.48%</td>
                                        <td>1.49%</td>
                                        <td>1.41%</td>
                                        <td>1.54%</td>
                                        <td>19.31%</td>
                                        <td>82.83%</td>
                                    </tr>
                                    <tr>
                                        <td>% CDI</td>
                                        <td>152%</td>
                                        <td>149%</td>
                                        <td>151%</td>
                                        <td>153%</td>
                                        <td>148%</td>
                                        <td>144%</td>
                                        <td>146%</td>
                                        <td>138%</td>
                                        <td>134%</td>
                                        <td>134%</td>
                                        <td>134%</td>
                                        <td>133%</td>
                                        <td>146%</td>
                                        <td>161%</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2">2016</td>
                                        <td>Fundo</td>
                                        <td>1.40%</td>
                                        <td>1.37%</td>
                                        <td>1.58%</td>
                                        <td>1.38%</td>
                                        <td>1.56%</td>
                                        <td>1.75%</td>
                                        <td>1.57%</td>
                                        <td>1.72%</td>
                                        <td>1.56%</td>
                                        <td>1.49%</td>
                                        <td>1.47%</td>
                                        <td>1.70%</td>
                                        <td>20.22%</td>
                                        <td>119.80%</td>
                                    </tr>
                                    <tr>
                                        <td>% CDI</td>
                                        <td>133%</td>
                                        <td>137%</td>
                                        <td>136%</td>
                                        <td>131%</td>
                                        <td>141%</td>
                                        <td>151%</td>
                                        <td>142%</td>
                                        <td>141%</td>
                                        <td>141%</td>
                                        <td>143%</td>
                                        <td>142%</td>
                                        <td>152%</td>
                                        <td>144%</td>
                                        <td>165%</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2">2017</td>
                                        <td>Fundo</td>
                                        <td>1.70%</td>
                                        <td>1.39%</td>
                                        <td>1.42%</td>
                                        <td>1.26%</td>
                                        <td>1.42%</td>
                                        <td>1.32%</td>
                                        <td>1.36%</td>
                                        <td>1.34%</td>
                                        <td>1.21%</td>
                                        <td>1.16%</td>
                                        <td>1.12%</td>
                                        <td>1.10%</td>
                                        <td>17.02%</td>
                                        <td>157.21%</td>
                                    </tr>
                                    <tr>
                                        <td>% CDI</td>
                                        <td>156%</td>
                                        <td>161%</td>
                                        <td>135%</td>
                                        <td>160%</td>
                                        <td>153%</td>
                                        <td>163%</td>
                                        <td>170%</td>
                                        <td>168%</td>
                                        <td>189%</td>
                                        <td>180%</td>
                                        <td>198%</td>
                                        <td>204%</td>
                                        <td>171%</td>
                                        <td>175%</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2">2018</td>
                                        <td>Fundo</td>
                                        <td>1.29%</td>
                                        <td>0.98%</td>
                                        <td>1.07%</td>
                                        <td>0.99%</td>
                                        <td>1.00%</td>
                                        <td>1.03%</td>
                                        <td>1.01%</td>
                                        <td>1.02%</td>
                                        <td>0.90%</td>
                                        <td>1.11%</td>
                                        <td>1.03%</td>
                                        <td>0.99%</td>
                                        <td>13.16%</td>
                                        <td>191.05%</td>
                                    </tr>
                                    <tr>
                                        <td>% CDI</td>
                                        <td>221%</td>
                                        <td>210%</td>
                                        <td>202%</td>
                                        <td>191%</td>
                                        <td>194%</td>
                                        <td>198%</td>
                                        <td>186%</td>
                                        <td>181%</td>
                                        <td>193%</td>
                                        <td>204%</td>
                                        <td>209%</td>
                                        <td>201%</td>
                                        <td>205%</td>
                                        <td>187%</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2">2019</td>
                                        <td>Fundo</td>
                                        <td>1.08%</td>
                                        <td>0.91%</td>
                                        <td>0.90%</td>
                                        <td>1.04%</td>
                                        <td>1.00%</td>
                                        <td>0.97%</td>
                                        <td>1.09%</td>
                                        <td>0.93%</td>
                                        <td>0.91%</td>
                                        <td>0.91%</td>
                                        <td>0.93%</td>
                                        <td>1.01%</td>
                                        <td>12.33%</td>
                                        <td>226.94%</td>
                                    </tr>
                                    <tr>
                                        <td>% CDI</td>
                                        <td>200%</td>
                                        <td>185%</td>
                                        <td>193%</td>
                                        <td>201%</td>
                                        <td>184%</td>
                                        <td>206%</td>
                                        <td>192%</td>
                                        <td>185%</td>
                                        <td>196%</td>
                                        <td>189%</td>
                                        <td>244%</td>
                                        <td>267%</td>
                                        <td>207%</td>
                                        <td>199%</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2">2020</td>
                                        <td>Fundo</td>
                                        <td>1.04%</td>
                                        <td>0.77%</td>
                                        <td>0.77%</td>
                                        <td>0.70%</td>
                                        <td>0.58%</td>
                                        <td>0.72%</td>
                                        <td>0.82%</td>
                                        <td>0.84%</td>
                                        <td>0.93%</td>
                                        <td>0.79%</td>
                                        <td>0.90%</td>
                                        <td>0.82%</td>
                                        <td>10.12%</td>
                                        <td>260.01%</td>
                                    </tr>
                                    <tr>
                                        <td>% CDI</td>
                                        <td>277%</td>
                                        <td>260%</td>
                                        <td>225%</td>
                                        <td>244%</td>
                                        <td>245%</td>
                                        <td>336%</td>
                                        <td>420%</td>
                                        <td>521%</td>
                                        <td>592%</td>
                                        <td>500%</td>
                                        <td>604%</td>
                                        <td>522%</td>
                                        <td>366%</td>
                                        <td>217%</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2">2021</td>
                                        <td>Fundo</td>
                                        <td>0.69%</td>
                                        <td>0.51%</td>
                                        <td>0.70%</td>
                                        <td>0.53%</td>
                                        <td>0.56%</td>
                                        <td>0.60%</td>
                                        <td>0.57%</td>
                                        <td>0.74%</td>
                                        <td>0.67%</td>
                                        <td>0.66%</td>
                                        <td>0.68%</td>
                                        <td>0.97%</td>
                                        <td>8.16%</td>
                                        <td>289.38%</td>
                                    </tr>
                                    <tr>
                                        <td>% CDI</td>
                                        <td>458%</td>
                                        <td>378%</td>
                                        <td>355%</td>
                                        <td>255%</td>
                                        <td>211%</td>
                                        <td>196%</td>
                                        <td>160%</td>
                                        <td>175%</td>
                                        <td>152%</td>
                                        <td>137%</td>
                                        <td>115%</td>
                                        <td>127%</td>
                                        <td>186%</td>
                                        <td>223%</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2">2022</td>
                                        <td>Fundo</td>
                                        <td>0.85%</td>
                                        <td>0.91%</td>
                                        <td>1.23%</td>
                                        <td>0.97%</td>
                                        <td>1.14%</td>
                                        <td>1.11%</td>
                                        <td>1.12%</td>
                                        <td>1.15%</td>
                                        <td>-4.55%</td>
                                        <td>0.65%</td>
                                        <td>-0.44%</td>
                                        <td>-0.75%</td>
                                        <td>3.31%</td>
                                        <td>302.27%</td>
                                    </tr>
                                    <tr>
                                        <td>% CDI</td>
                                        <td>116%</td>
                                        <td>122%</td>
                                        <td>133%</td>
                                        <td>117%</td>
                                        <td>110%</td>
                                        <td>110%</td>
                                        <td>108%</td>
                                        <td>99%</td>
                                        <td>-</td>
                                        <td>64%</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>27%</td>
                                        <td>191%</td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2">2023</td>
                                        <td>Fundo</td>
                                        <td>-4.19%</td>
                                        <td>-0.43%</td>
                                        <td>0.55%</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-4.07%</td>
                                        <td>285.89%</td>
                                    </tr>
                                    <tr>
                                        <td>% CDI</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>46%</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>172%</td>
                                    </tr>
                                </tbody>
                            </table>
                            <p className="text-sm text-gray-600">
                                * A rentabilidade desde o início refere-se a data de início da última gestão do Fundo, em 21/09/2011.
                            </p>
                        </div>
                    </details>
                    <details>
                        <summary className="sumario">
                            Histórico da gestão Polígono Capital Ltda. | A partir de 17 de abril de 2023
                        </summary>
                        <div className="mt-4">
                            <table className="w-full table">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th>JAN</th>
                                        <th>FEV</th>
                                        <th>MAR</th>
                                        <th>ABR</th>
                                        <th>MAI</th>
                                        <th>JUN</th>
                                        <th>JUL</th>
                                        <th>AGO</th>
                                        <th>SET</th>
                                        <th>OUT</th>
                                        <th>NOV</th>
                                        <th>DEZ</th>
                                        <th>ANO</th>
                                        <th>DESDE O INÍCIO*</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td rowspan="2">2023</td>
                                        <td>Fundo</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>0.35%*</td>
                                        <td>1.07%</td>
                                        <td>1.09%</td>
                                        <td>1.13%</td>
                                        <td>1.18%</td>
                                        <td>1.26%</td>
                                        <td>1.32%</td>
                                        <td>1.08%</td>
                                        <td>1.02%</td>
                                        <td>9.90%</td>
                                        <td>9.90%</td>
                                    </tr>
                                    <tr>
                                        <td>% CDI</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>85.50%</td>
                                        <td>95.06%</td>
                                        <td>101.90%</td>
                                        <td>105.43%</td>
                                        <td>103.19%</td>
                                        <td>129.45%</td>
                                        <td>131.92%</td>
                                        <td>117.88%</td>
                                        <td>113.94%</td>
                                        <td>110.81%</td>
                                        <td>110.81%</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2">2024</td>
                                        <td>Fundo</td>
                                        <td>1.03%</td>
                                        <td>1.02%</td>
                                        <td>0.94%</td>
                                        <td>1.00%</td>
                                        <td>0.96%</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>5.05%</td>
                                        <td>15.45%</td>
                                    </tr>
                                    <tr>
                                        <td>% CDI</td>
                                        <td>106.82%</td>
                                        <td>127.01%</td>
                                        <td>112.25%</td>
                                        <td>113.00%</td>
                                        <td>115.10%</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>114.77%</td>
                                        <td>112.55%</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                            <p className="text-sm text-gray-600">
                                * A rentabilidade desde o início refere-se a data de início da gestão Polígono Capital Ltda. em 17/04/2023.
                            </p>
                        </div>
                    </details>
                </div>

            </section>
            <section id="nota" className="mb8 container">
                <p>
                    <strong>
                        Em 06 de março de 2023, a assembleia geral de cotistas do fundo Orion Fundo de Investimento em Cotas de Fundo de Investimento Multimercado – Crédito Privado (“Fundo”) decidiu pela alteração da instituição responsável pela gestão da carteira (“Gestora”) do Fundo. Na data de 17 de abril de 2023, (i) a Polígono Capital Ltda (“Polígono”) assume o papel de Gestora do Fundo, (ii) inicia o acompanhamento e divulgação de cota diária e rentabilidade e, conforme alterado, (iii) o Fundo deixa de contar com existência de taxa de performance.
                    </strong>
                    As informações sobre rentabilidade do Fundo no período de 26 de setembro de 2016 até 16 de abril de 2023 são de responsabilidade da instituição responsável pela gestão da carteira no período mencionado e podem vir a ser utilizadas pela Polígono para fins de continuidade da série histórica. Este Material foi elaborado pela Polígono Capital Ltda., na qualidade de Gestora do Fundo, com finalidade exclusivamente informativa. A Polígono não comercializa e nem distribui cotas de fundos de investimentos. Fundos não contam com garantia do administrador do Fundo, do gestor da carteira, de qualquer mecanismo de seguro ou, ainda, do Fundo Garantidor de Crédito – FGC. Ao investidor, é recomendada a leitura cuidadosa do regulamento do Fundo ao aplicar seus recursos. Leia o prospecto e o regulamento antes de investir. A rentabilidade obtida no passado não representa garantia de rentabilidade futura e a rentabilidade divulgada não é liquida de impostos. Não há garantia de que este Fundo terá o tratamento tributário para fundos de longo prazo. O presente material não constitui oferta e/ou recomendação e/ou solicitação para subscrição ou compra de quaisquer valores mobiliários. As informações aqui contidas refletem o atual julgamento da Polígono na data de sua divulgação e estão, portanto, sujeitas a alterações sem aviso prévio. As projeções utilizam dados históricos e suposições, de forma que (i) não estão livres de erros; (ii) não é possível garantir que os cenários obtidos venham efetivamente a ocorrer; (iii) não configuram, em nenhuma hipótese, promessa ou garantia de retorno esperado nem de exposição máxima de perda; e (iv) não devem ser utilizadas para embasar nenhum procedimento administrativo perante órgãos fiscalizadores ou reguladores. A Polígono não declara ou garante, de forma expressa ou implícita, a integridade, confiabilidade ou exatidão de tais informações e se exime de qualquer responsabilidade por quaisquer prejuízos, diretos ou indiretos, que venham a decorrer da utilização desse material e de seu conteúdo. Este material apresenta informações resumidas e não é um documento completo, de modo que os investidores devem ler o regulamento e demais documentos legais do Fundo antes de investir. Os fundos de crédito privado estão sujeitos a risco de perda substancial de seu patrimônio líquido em caso de eventos que acarretem o não pagamento dos ativos integrantes de sua carteira, inclusive por força de intervenção, regime de administração temporária, falência, recuperação judicial ou extrajudicial dos emissores responsáveis pelos ativos do Fundo.
                </p>
            </section>
        </main>
    );
};

export default Orion;